export default __webpack_public_path__ + "static/media/2279.6930c6e3.png";